import stopNumberMousewheel from './stopNumberMousewheel'

const install = function(Vue) {
  Vue.directive('stopNumberMousewheel', stopNumberMousewheel)
}

if (window.Vue) {
  window['stopNumberMousewheel'] = stopNumberMousewheel
  Vue.use(install); // eslint-disable-line
}

stopNumberMousewheel.install = install
export default stopNumberMousewheel
